/*global dataLayer*/
import React, { useEffect } from "react";
import styled from "styled-components";
import { withRouter, useHistory } from "react-router-dom";
import { withTheme } from "@material-ui/styles";
import { fireImpressionEvent, fireStartEvent } from "../utils/gtm-events";

import Page from "../layout/Page";
import ImageBanner from "../layout/ImageBanner";
import BackgroundImage from "../images/light-car-background.png";
import WhatsMyTradeInWorth from "../components/WhatsMyTradeInWorthHeader";
import HowDoesItWork from "../components/HowDoesItWork";
import useAccountSettings from "../hooks/useAccountSettings";
import useTradeInState from "../hooks/useTradeInState";
import uuid from "uuid";
import Search from "../containers/Search";

const ImageBannerStyled = styled(ImageBanner)`
  padding: 20px 10px;
`;

const ContentWrapper = withTheme(styled.div`
  display: flex;

  min-height: 650px;

  ${(props) => props.theme.breakpoints.down("sm")} {
    min-height: 250px;
  }

  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`);

const LandingPage = ({ match, children, theme, ...props }) => {
  const { params } = match;
  const { accountId } = params;
  const [{ accountName, removeBranding, hideDecorativeImagery }] = useAccountSettings({ accountId });
  const history = useHistory();

  const [state, update] = useTradeInState();

  useEffect(() => {
    fireImpressionEvent({ leadId: state.leadId });
  }, [state.leadId]);

  useEffect(() => {
    if (accountId) {
      dataLayer.push({ accountId });
    }
  }, [accountId]);

  const handleOnSubmit = ({ ymmtIds, vin }) => {
    const { yearId, makeId, modelId, trimId } = ymmtIds;
    // Create a new lead every time the user starts a new trade in report.
    update("leadId", uuid());
    if (vin) {
      update("vin", vin);
    }
    history.push(`/${accountId}/${yearId}/${makeId}/${modelId}/${trimId}`);
  };

  const header = (
    <ImageBannerStyled
      src={BackgroundImage}
      height={350}
      backgroundColor="#746b75"
    >
      <ContentWrapper>
        <WhatsMyTradeInWorth removeBranding={removeBranding} />
        <Search handleOnSubmit={handleOnSubmit} accountId={accountId}></Search>
      </ContentWrapper>
    </ImageBannerStyled>
  );

  return (
    <div>
      <Page
        header={header}
        footer={children}
        onClick={() => fireStartEvent({ leadId: state.leadId })}
      >
        <HowDoesItWork hideDecorativeImagery={hideDecorativeImagery} accountName={accountName} />
      </Page>
    </div>
  );
};

export default withTheme(withRouter(LandingPage));
